import {Box, Grid, IconButton, Stack, Typography} from '@mui/material';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet, useNavigate} from 'react-router-dom';

import {containersQuery, containersService} from '@store/settings/containers';

import {GroupAction} from '@icons/index';

import InfosCard from '@components/cards/infos/Infos.card';

import {Colors} from '@constants/colors.constants';

const ContainersTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();

  const [{containers}] = useObservable(containersQuery.containers$);

  useEffect(() => {
    containersService.getContainers().subscribe({
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  }, [enqueueSnackbar]);

  return (
    <>
      <Stack flex={1} spacing={1} p="25px" overflow="hidden">
        <Typography fontSize="30px" fontWeight="700">
          {t('routes.containers')}
        </Typography>
        <Box flex={1} pt="25px" overflow="hidden">
          <Stack height="100%" overflow="hidden" borderRadius="4px" bgcolor={Colors.white}>
            <Stack p="30px" overflow="auto" className="scrollable">
              <Grid container spacing={2} columns={6}>
                {containers?.map((container) => (
                  <Grid item key={container.id} xs={1}>
                    <InfosCard
                      title={container.name}
                      menuOptions={(
                        <>
                          <IconButton
                            sx={{mr: '-7px'}}
                            onClick={(evt) => {
                              evt.stopPropagation();
                              navigate(`${container.id}`);
                            }}>
                            <GroupAction style={{height: 14, width: 14}}/>
                          </IconButton>
                        </>
                      )}
                      unit={t('global.m3', {value: container.volume})}/>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <Outlet/>
    </>
  );
};

export default ContainersTab;
